export const headerTextbook = 'Учебник'
export const section = [
  {
    textName: 'Раздел 1',
    color: '#4640BE',
    value: 1,
  },
  {
    textName: 'Раздел 2',
    color: '#732e70',
    value: 2,
  },
  {
    textName: 'Раздел 3',
    color: '#E38627',
    value: 3,
  },
  {
    textName: 'Раздел 4',
    color: '#fb8484',
    value: 4,
  },
  {
    textName: 'Раздел 5',
    color: '#7984dc',
    value: 5,
  },
  {
    textName: 'Раздел 6',
    color: '#b8495b',
    value: 6,
  },
  {
    textName: 'Раздел 7',
    color: '#37373d',
    value: 7,
  },
]

export const page = [
  {
    textName: 'Страница 1',
    value: 1,
  },
  {
    textName: 'Страница 2',
    value: 2,
  },
  {
    textName: 'Страница 3',
    value: 3,
  },
  {
    textName: 'Страница 4',
    value: 4,
  },
  {
    textName: 'Страница 5',
    value: 5,
  },
  {
    textName: 'Страница 6',
    value: 6,
  },
  {
    textName: 'Страница 7',
    value: 7,
  },
  {
    textName: 'Страница 8',
    value: 8,
  },
  {
    textName: 'Страница 9',
    value: 9,
  },
  {
    textName: 'Страница 10',
    value: 10,
  },
  {
    textName: 'Страница 11',
    value: 11,
  },
  {
    textName: 'Страница 12',
    value: 12,
  },
  {
    textName: 'Страница 13',
    value: 13,
  },
  {
    textName: 'Страница 14',
    value: 14,
  },
  {
    textName: 'Страница 15',
    value: 15,
  },
  {
    textName: 'Страница 16',
    value: 16,
  },
  {
    textName: 'Страница 17',
    value: 17,
  },
  {
    textName: 'Страница 18',
    value: 18,
  },
  {
    textName: 'Страница 19',
    value: 19,
  },
  {
    textName: 'Страница 20',
    value: 20,
  },
  {
    textName: 'Страница 21',
    value: 21,
  },
  {
    textName: 'Страница 22',
    value: 23,
  },
  {
    textName: 'Страница 23',
    value: 23,
  },
  {
    textName: 'Страница 24',
    value: 24,
  },
  {
    textName: 'Страница 25',
    value: 25,
  },
  {
    textName: 'Страница 26',
    value: 26,
  },
  {
    textName: 'Страница 27',
    value: 27,
  },
  {
    textName: 'Страница 28',
    value: 28,
  },
  {
    textName: 'Страница 29',
    value: 29,
  },
  {
    textName: 'Страница 30',
    value: 30,
  },
]
